import { useEffect, useRef } from "react";

import type { UserDisplayName } from "./use-user-display-names";

/** Committed, registry-ID-keyed display snapshots for surfaces that retain last-good names on errors. */
export function useLastResolvedUserDisplayNames(users: Record<string, UserDisplayName>) {
  const retained = useRef<Record<string, Extract<UserDisplayName, { status: "resolved" }>>>({});
  useEffect(() => {
    Object.entries(users).forEach(([id, result]) => {
      if (result.status === "resolved") retained.current[id] = result;
    });
  }, [users]);
  return retained.current;
}
